import { jsx as _jsx } from "react/jsx-runtime";
export function Button({ variant = "primary", size = "md", className = "", children, ...props }) {
    const sizeClasses = {
        sm: "px-3 py-1.5 text-xs",
        md: "px-4 py-2",
        lg: "px-6 py-3",
    };
    const baseClasses = `rounded-[6px] transition-colors font-normal flex items-center justify-center ${sizeClasses[size]}`;
    const variantClasses = {
        primary: "bg-duvi-accent text-white hover:bg-duvi-accent-hover",
        secondary: "bg-duvi-surface border border-duvi-border text-duvi-text-primary hover:bg-duvi-elevated",
    };
    return (_jsx("button", { className: `${baseClasses} ${variantClasses[variant] ?? variantClasses.primary} ${className}`, style: { fontSize: size === "sm" ? "var(--text-xs)" : "var(--text-sm)" }, ...props, children: children }));
}
//# sourceMappingURL=Button.js.map